import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    modules: [],
    deletedModuleSuccess: null,
    createdModuleSuccess: null,
    updatedModuleSuccess: null,
    updatedCardSuccess: null,
    rollups: {},
    entityId: null,
    sheets: null,
    fileName: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.MODULES_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.MODULES_FETCH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modules: [
                    ...action.data
                ]
            }

        case types.MODULES_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.CREATE_MODULE_SUCCESS:
            return {
                ...state,
                createdModuleSuccess: action.item.id,
                modules: [
                    ...action.data
                ]
            }

        case types.CREATE_MODULE_FAILED:
            return {
                ...state
            }

        case types.DELETE_MODULE_SUCCESS:
            return {
                ...state,
                deletedModuleSuccess: action.id,
                modules: [
                    ...action.data
                ]
            }

        case types.DELETE_MODULE_FAILED:
            return {
                ...state
            }

        case types.UPDATE_MODULE_SUCCESS:
            return {
                ...state,
                updatedModuleSuccess: action.item.id,
                modules: [
                    ...action.data
                ]
            }

        case types.UPDATE_MODULE_FAILED:
            return {
                ...state
            }

        case types.RESET_MODULE_NOTIFICATION:
            return {
                ...state,
                deletedModuleSuccess: null,
                createdModuleSuccess: null,
                updatedModuleSuccess: null,
                updatedCardSuccess: null
            }

        case types.CREATE_CARD:
            return {
                ...state,
                isLoading: true
            }

        case types.CREATE_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modules: [
                    ...action.data
                ]
            }

        case types.CREATE_CARD_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.UPDATE_CARD:
            return {
                ...state,
                isLoading: true
            }

        case types.UPDATE_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedCardSuccess: action.item.id,
                modules: [
                    ...action.data
                ]
            }

        case types.UPDATE_CARD_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.DELETE_CARD:
            return {
                ...state,
                isLoading: true
            }

        case types.DELETE_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modules: [
                    ...action.data
                ]
            }

        case types.DELETE_CARD_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.GET_ROLLUP:
            return {
                ...state,
                rollups: {
                    ...state.rollups,
                    [action.cardId]: undefined
                }
            }

        case types.GET_ROLLUP_SUCCESS:
            return {
                ...state,
                rollups: {
                    ...state.rollups,
                    [action.cardId]: action.rollup
                }
            }

        case types.GET_ROLLUP_FAILED:
            return {
                ...state
            }

        case types.SHEETS_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.SHEETS_FETCH_SUCCESS:
            return {
                ...state,
                // isLoading: !action.data.sheets.length || action.data.sheets.length > 1 ? false : true,
                isLoading: false,
                sheets: action.data.sheets,
                fileName: action.data.fileName
            }

        case types.SHEETS_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.EXCEL_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.EXCEL_FETCH_SUCCESS:
            return {
                ...state,
				modules: [...action.data],
                entityId: action.entity,
                isLoading: false
            }

        case types.EXCEL_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SHEETS_RESET:
            return {
                ...state,
                fileName: null,
                sheets: null,
                entityId: null
            }

        case types.COPY_CARD:
            return {
                ...state,
                isLoading: true
            }

        case types.COPY_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modules: [
                    ...action.data
                ]
            }

        case types.COPY_CARD_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.RENAME_CARD_SUCCESS:
            return {
                ...state,
				updatedCardSuccess: true,
				modules: [
                    ...action.data
                ]
            }

        case types.RENAME_CARD_FAILED:
            return {
                ...state
            }

        default:
            return state
    }
}
